import { action } from "mobx";
import { Account } from "./Account";
import { comm } from '../../comm';

export class FacebookAccount extends Account{

	getFreshToken(){
		return new Promise((resolve, reject) => {
			if(!this.isConnected){
				// window.store.debugArray.push(`fb not connected`)
				resolve('');
				return;
			}
			//valid if does not expire in the next 30 minutes.
			const currentToken = this.localData.token;
			FB.api("/me", 'GET', {
				"access_token": currentToken
			},
			(response) => {
				if (response && !response.error) {
					resolve(currentToken)
				} else {
					// window.store.debugArray.push(`fb /me responded with error ${JSON.stringify(response)}`)
					this.reset();
					if(response.error.type === 'OAuthException'){
						window.WrapperApp.postMessage('fblogin');
						var count = 0;
						var interval = setInterval(() => {
							if(count < 10){
								count++;
								if(this.localData.token !== currentToken){
									// window.store.debugArray.push(`got new token from fb`)
									resolve(this.localData.token);
								}
							} else {
								clearInterval(interval);
								// window.store.debugArray.push(`fb token wait timed out`)
								console.warn('check session timed out waiting for facebook');
								resolve('');
							}
						}, 500);
						console.log('interval', interval)
					}
				}
			});
		})
	}

	@action.bound getProfileData(){
		return new Promise((resolve, reject) => {
			// window.store.debugArray.push(`46 getting fb profile data`)
			this.getFreshToken()
			.then((token) => {
				// window.store.debugArray.push(`49 token is fresh ${token}`)
				var accessToken = token;
				if(accessToken){
					// window.store.debugArray.push(`exp: ${this.localData.expiration > (Date.now() / 1000)} -- ${this.localData.expiration}`);
					FB.api(
						'/me',
						'GET',
						{
							"fields":"id,email,first_name,picture.width(300).height(300)",
							"access_token": accessToken
						},
						(response) => {
							if(response.error && response.error.code){
								console.warn('FB Profile Error', response.error);
								//expired token
								// if(response.error.code === 190){
								// 	this.localData.expiration = 0;
								// 	return this.getProfileData();
								// }
								// window.store.debugArray.push(`error on fb api ${JSON.stringify(response)}`)
								resolve(["FB Profile Error", ""])
								// reject(response.error.message);
							} else {
								// Insert your code here
								console.log('FB profile response:', response);
								// window.store.debugArray.push(`fb response ${JSON.stringify(response)}`)
								this.profile.display = response.first_name;
								this.profile.avatar = response.picture.data.url;
								comm.SetPlatformData('fb',response.id,response.email);
								resolve([response.first_name, response.picture.data.url])
							}
						}
					);
				} else {
					// window.store.debugArray.push(`token false ${accessToken}`)
					reject('No usable FB auth token');
				}
			})

		})
	}

}
